import*as r from"react";import{IconsContext as e}from"./IconsContext.mjs";function o({children:o,icons:t}){return r.createElement(e.Provider,{value:t},o)}export{o as IconsProvider};
